import DadLogo from "@/components/DadLogo";
import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ScanLine } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-10">
          <DadLogo className="dad-logo-auth" data-testid="login-wordmark" />
          <p className="text-gray-400 mt-5 text-sm">Il cervello della tua azienda.</p>
        </div>

        <form onSubmit={submit} className="glass rounded-3xl p-8 space-y-4" data-testid="login-form">
          <div>
            <label htmlFor="login-email" className="text-xs text-gray-500 mb-1.5 block">Email</label>
            <input id="login-email" data-testid="login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="input-dark"
              placeholder="nome@azienda.ch" autoComplete="email" />
          </div>
          <div>
            <label htmlFor="login-password" className="text-xs text-gray-500 mb-1.5 block">Password</label>
            <input id="login-password" data-testid="login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="input-dark"
              placeholder="••••••••" autoComplete="current-password" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-2.5">{error}</div>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Accesso in corso…" : "Entra nella tua azienda"}
          </button>
          <button type="button" data-testid="login-demo-fill"
            onClick={() => { setEmail("christian.canzetti@gmail.com"); setPassword("DadBrain2026!"); }}
            className="btn-ghost w-full !text-xs">
            <ScanLine size={14} /> Compila con account demo
          </button>
          <div className="text-center">
            <Link to="/forgot-password" data-testid="login-forgot-link" className="text-xs text-gray-500 hover:text-cyan-300 transition-colors">
              Password dimenticata?
            </Link>
          </div>
        </form>

        <p className="text-center text-xs text-gray-600 mt-8 leading-relaxed">
          Tu fai l'imprenditore.<br />Il sistema tiene sotto controllo l'azienda.
        </p>
      </div>
    </div>
  );
}
